import type { Theme } from '@material-ui/core'
import type { CSSProperties } from '@material-ui/styles'

/**
 * The chip look for a `{{key}}` template placeholder. Lives here rather than inside the editor's
 * styles because placeholders render in two places: inside the RTE while a field is being edited,
 * and as read-only `HtmlContent` everywhere else that wants to *show* tags without resolving them
 * (see `templateToPlaceholderHtml`). One definition so the two can't drift apart visually.
 *
 * Consumers nest it under whatever selector owns the markup, e.g. `'& .template-placeholder'`.
 */
export const templatePlaceholderStyles = (theme: Theme): CSSProperties => ({
  paddingLeft: theme.size['1'],
  paddingRight: theme.size['1'],
  paddingTop: theme.size['0.25'],
  paddingBottom: theme.size['0.25'],
  marginTop: theme.spacing(0.25),
  marginBottom: theme.spacing(0.25),
  marginLeft: theme.spacing(0.25),
  marginRight: theme.spacing(0.25),
  fontWeight: theme.typography.fontWeightMedium,
  borderRadius: theme.borderRadius.md,
  border: `1px solid ${theme.palette.common.black}`,
  display: 'inline-block',
  verticalAlign: 'baseline',
  pointerEvents: 'none',
  userSelect: 'none',
  '&::after': {
    content: '""',
    display: 'inline-block',
    width: theme.size['0.25'],
    height: 1
  }
})

/**
 * Placeholders are taller than plain text, so lines containing one need a little extra leading to
 * stop the chip border colliding with the line above.
 */
export const templatePlaceholderLineHeight = { lineHeight: 1.5 }
